var _style, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#020203;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:#020203;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.93,217.4c-0.01-0.01-0.02-0.02-0.03-0.03L282.92,13.41c-8.69-8.7-20.25-13.49-32.55-13.49 c-12.3,0-23.86,4.79-32.55,13.48L13.94,217.26c-0.07,0.07-0.14,0.14-0.21,0.21c-17.85,17.96-17.82,47.09,0.09,65 c8.18,8.19,18.99,12.93,30.55,13.42c0.47,0.05,0.94,0.07,1.42,0.07h8.13v150.1c0,29.7,24.17,53.87,53.88,53.87h79.8 c8.09,0,14.65-6.56,14.65-14.65V367.6c0-13.55,11.03-24.58,24.58-24.58h47.07c13.56,0,24.58,11.02,24.58,24.58v117.68 c0,8.09,6.56,14.65,14.65,14.65h79.8c29.71,0,53.88-24.17,53.88-53.87v-150.1h7.54c12.29,0,23.85-4.79,32.55-13.48 C504.84,264.53,504.85,235.35,486.93,217.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M426.78,323.22c-27.23-27.23-59.64-47.39-95-59.59c37.87-26.08,62.75-69.74,62.75-119.1 C394.53,64.84,329.69,0,250,0S105.47,64.84,105.47,144.53c0,49.36,24.88,93.02,62.76,119.1c-35.36,12.2-67.77,32.36-95,59.59 C26,370.44,0,433.22,0,500h39.06c0-116.31,94.63-210.94,210.94-210.94S460.94,383.69,460.94,500H500 C500,433.22,474,370.44,426.78,323.22z M250,250c-58.16,0-105.47-47.31-105.47-105.47S191.84,39.06,250,39.06 s105.47,47.31,105.47,105.47S308.16,250,250,250z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.19,18.31c24.41,24.41,24.41,63.98,0,88.39c-24.41,24.41-63.98,24.41-88.39,0s-24.41-63.98,0-88.39 C230.21-6.1,269.79-6.1,294.19,18.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.19,205.81c24.41,24.41,24.41,63.98,0,88.39c-24.41,24.41-63.98,24.41-88.39,0s-24.41-63.98,0-88.39 C230.21,181.4,269.79,181.4,294.19,205.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.19,393.31c24.41,24.41,24.41,63.98,0,88.39c-24.41,24.41-63.98,24.41-88.39,0 c-24.41-24.41-24.41-63.98,0-88.39C230.21,368.9,269.79,368.9,294.19,393.31"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c3cda76b.svg";
export { ForwardRef as ReactComponent };